export const planYourVisitQuery = `
query getPlanYourVisit {
  planYourVisit {
    admission {
      anchor
      button_link
      button_link_behavior
      button_link_text
      cta_link
      cta_link_behavior
      cta_link_text
      cta_text
      heading
      subheading
      suppressed
      column_one {
        text
        value
      }
      column_two {
        text
        value
      }
    }
    blocks {
      anchor
      column_one_content
      column_one_image {
        altText
        imageSrcset
        sourceUrl
      }
      column_one_link
      column_one_link_behavior
      column_one_link_text
      column_one_subheading
      column_two_content
      column_two_image {
        altText
        imageSrcset
        sourceUrl
      }
      column_two_link
      column_two_link_behavior
      column_two_link_text
      column_two_subheading
      heading
      type
    }
    directions {
      anchor
      heading
      address {
        subheading
        street
        map_image {
          altText
          imageSrcset
          sourceUrl
        }
        map_link
        map_link_behavior
        map_link_text
      }
      transit{
        directions {
          title
          direction
        }
        subheading
      }
      parking_link
      parking_link_behavior
      parking_link_text
    }
    excerpt
    featuredImage {
      altText
      sourceUrl
    }
    featuredImageWidth
    imageSrcset
    hours {
      anchor
      heading
      holiday_hours
      holiday_hours_label
      regular_hours
      regular_hours_label
      special_hours
      special_hours_label
    }
    secondary_nav {
      label
      url
    }
    title
    video
  }
}`;
